import { featureFlagKeySchema } from "@redotech/feature-flags-model/schema";
import * as z from "zod";
import { deprecatedAlwaysOnFeatureFlagKeys } from "./get-feature-flag";

/** Batched getFeatureFlag: one round trip for a page's whole flag set. */
export const getFeatureFlags = {
  name: "getFeatureFlags" as const,
  input: z.object({
    flagKeys: z.array(
      z.union([
        featureFlagKeySchema,
        z.enum(deprecatedAlwaysOnFeatureFlagKeys),
      ]),
    ),
  }),
  output: z.object({ flags: z.record(z.string(), z.boolean()) }),
};
